import { createSignal } from "solid-js"
import { EngineMode } from "../../lib/core/engine/EngineMode/EngineMode.enum"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useEngineModeSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<EngineMode>(EngineMode.MapEditor)

  return signal
})


